var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.293 20.707C9.4816 20.8892 9.7342 20.99 9.9964 20.9877C10.2586 20.9854 10.5094 20.8802 10.6948 20.6948C10.8802 20.5094 10.9854 20.2586 10.9877 19.9964C10.99 19.7342 10.8892 19.4816 10.707 19.293L4.414 13H22C22.2652 13 22.5196 12.8946 22.7071 12.7071C22.8946 12.5196 23 12.2652 23 12C23 11.7348 22.8946 11.4804 22.7071 11.2929C22.5196 11.1054 22.2652 11 22 11H4.414L10.707 4.707C10.8892 4.5184 10.99 4.2658 10.9877 4.0036C10.9854 3.7414 10.8802 3.49059 10.6948 3.30518C10.5094 3.11977 10.2586 3.0146 9.9964 3.01233C9.7342 3.01005 9.4816 3.11084 9.293 3.293L1.293 11.293C1.20036 11.3861 1.12696 11.4965 1.077 11.618C1.02617 11.7389 0.999994 11.8688 0.999994 12C0.999994 12.1312 1.02617 12.2611 1.077 12.382C1.12696 12.5035 1.20036 12.6139 1.293 12.707L9.293 20.707Z",
    fill: "#001D9A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.b64b48389f510de3f5d59d2a5597eb3c.svg";
export { ForwardRef as ReactComponent };